export default __webpack_public_path__ + "static/media/021-cubes.557c3671.png";